export default __webpack_public_path__ + "static/media/pic4.ab766959.jpg";